// /* eslint-disable react/jsx-no-undef */
/* eslint-disable no-unreachable */
import {
  createRef,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";

// import styled, { css } from "styled-components";
// import { Avatar, Progress, Select } from "antd";
// import { PlusOutlined, MoreOutlined } from "@ant-design/icons";

import { useLocation, useNavigate } from "react-router-dom";
// import Drag from "assets/images/dragicon.svg";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { setCookie, getCookie } from "utils/StorageVariables";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { RetrieveMasterPlanDetails } from "Redux/RetrieveMasterPlan/action";
import { SetSelectedGoalAction, addTemporarilyVisibleCompletedGoal, clearTemporarilyVisibleCompletedGoals } from "Redux/Global/action";

// import OngoingIcon from "assets/images/journeys/ongoing.svg";
import plusIcon from "assets/images/journeys/plus.svg";

// import { ReactComponent as ThreeDotsIcon } from "assets/images/journeys/three-dots.svg";

import { DeleteActions } from "Redux/DeleteActions/action";
import { Error } from "Responses/Response";
import { UpdateActions } from "Redux/UpdateActions/action";
import { UpdateGoal } from "Redux/UpdateGoal/action";
import { CreateAction } from "Redux/CreateAction/action";
import { UpdateLastStep } from "Redux/UpdateLastStep/action";
import { PrioritizeActionPlan } from "Redux/PrioritizeActionPlans/action";
import { ListAccountabilities, CreateAccountability } from "Redux/ListAccountability/action";

import _ from "lodash";

import useDeviceType from "../../../Hooks/ResponsiveHook";
import "react-datepicker/dist/react-datepicker.css";
// import useWindowSize from "utils/useWindowSize";
// import { BREAKPOINTS } from "theme/mixins";
// import Switch from "react-switch";
// import LockedOver from "components/LockedOver/LockedOver";
import { UpdateUserArea } from "Redux/UpdateUserArea/action";
import CompleteActionItemModal from "components/CompleteActionItemModal";
import { AssistantProvider } from "components/InputAreaAI";
import LockedOver from "components/LockedOver/LockedOver";
import PlanShortcut from "components/PlanShortcut";
import Pagination from "components/Pagination";
import AccountabilitySelect, { getGroupedOptions, getOptionWithLabel } from "./AccountabilitySelect";

import Header from "./Header";
import Purpose from "./Purpose";
import Print from './Print';

// import { GetProgress } from "Redux/GetProgress/action";

import { MASTER_PATH, PURPOSE_PATH } from "utils/routes";

import * as Styles from "./styled.js";
import StepLayout from "../StepLayout/index";
import ActionItem, { DraggableActionItem } from "./ActionItem/index";
import Goal from "./Goal"; // Import the new Goal component

import TypeTooltip from "./TypeTooltip/index";

import { Toggle, Tooltip, Checkbox } from "elements";

import RadialBar from "components/PriorityApp/SimpleView/RadialBar";

import { GetPredefinedMetrics } from "Redux/GetPredefinedMetrics/action";
import { GetCustomMetrics } from "Redux/CustomMetrics/action";
import { GetActionsProgress } from "Redux/GetProgress/action";

import {
  CreateMetricsPopup,
  ManageMetricsPopup,
} from "../Measurement/ManageMetrics";

// import ChevronRightIcon from "assets/images/journeys/chevron-right.svg";
import CustomDatepicker from "./CustomDatepicker";

import { track } from 'utils/amplitude';
import Notify from "utils/notify";

// Custom hook to create a debounced function
const useDebouncedCallback = (callback, delay) => {
  const debouncedCallback = useCallback(
    _.debounce((...args) => callback(...args), delay),
    [callback, delay]
  );
  return debouncedCallback;
};

const Actions = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const location = useLocation();

  const $delay = useRef(false);
  const $addButtonRef = useRef(null);

  const queryParams = new URLSearchParams(location.search);
  const journey = queryParams.get('m');
  const sanitizedJourney = journey?.endsWith('/') ? journey?.slice(0, -1) : journey;
  
  const [actionPlanData, setActionPlanData] = useState([]);
  const [showCompletedActions, setShowCompletedActions] = useState(false);
  const [open, setOpen] = useState(null);
  // const [strategies, setStrategies] = useState([]);
  const [isAddCustomMetric, setIsAddCustomMetric] = useState(false);
  const [isManageMetric, setIsManageMetric] = useState(false);
  const screenSizes = useDeviceType();
  const isMobile = screenSizes === "mobile";
  const isTablet = screenSizes === "iPad";
  const isLargTablet = window.innerWidth > 1024 && window.innerWidth < 1256

  const { masterPlanDetails, loading: masterplanLoading } = useSelector(
    (state) => state.RetrieveMasterPlanDetailsReducer
  );
  const { selectedGoalAction, temporarilyVisibleCompletedGoals } = useSelector((state) => state.globalReducer);
  const { data: accountabilityData, custom: customAccountabilityData } = useSelector((state) => state.accountabilityReducer);
  const { loading } = useSelector((state) => state.createActionReducer);

  const { actions_progress: actionsProgress } = useSelector(
    (state) => state.getProgressReducer
  );

  const { SelectedClient } = useSelector((state) => state.globalReducer);

  // Initialize refs array
  /* if ($inputRefs.current.length !== selectedGoalAction.length) {
    $inputRefs.current = Array(selectedGoalAction.length)
      .fill(null)
      .map((_, i) => $inputRefs.current[i] || createRef());
  } */

  useEffect(() => {
    let MasterPlanId = sanitizedJourney || getCookie("MasterPlanId");
    if (sanitizedJourney ) {
      setCookie("MasterPlanId", sanitizedJourney);
    }
    dispatch(RetrieveMasterPlanDetails(MasterPlanId));
    dispatch(GetPredefinedMetrics());
    dispatch(GetCustomMetrics());
    
    // Clear temporarily visible completed goals when journey changes
    dispatch(clearTemporarilyVisibleCompletedGoals());
  }, [journey]);

  // Clear temporarily visible completed goals when component unmounts
  useEffect(() => {
    return () => {
      dispatch(clearTemporarilyVisibleCompletedGoals());
    };
  }, []);

  useEffect(() => {
    if (!masterPlanDetails?.journey?.id)
      return;

    dispatch(ListAccountabilities(masterPlanDetails?.journey?.id));
    dispatch(ListAccountabilities(masterPlanDetails?.journey?.id, true));
  }, [masterPlanDetails?.journey?.id]);

  useEffect(() => {
    if (!masterPlanDetails?.areas)
      return;

    setActionPlanData(SortArr([...masterPlanDetails?.areas?.filter(area =>
      !area.goal?.completed || temporarilyVisibleCompletedGoals.has(area.goal?.id)
    )]));
  }, [masterPlanDetails?.id, temporarilyVisibleCompletedGoals]);

  const SortArr = (data) =>
    data?.sort(function (a, b) {
      return a?.goal?.priority - b?.goal?.priority;
    });

  const handleUpdate = (
    actionId,
    foundAction,
    isProgress = false,
    showLoader = false
  ) => {
    return dispatch(
      UpdateActions(actionId, { ...foundAction }, isProgress, { showLoader })
    );
  };

  const debouncedHandleUpdate = useDebouncedCallback(handleUpdate, 500);

  /* const handleUpdate = useCallback(
    _.debounce(
      (actionId, foundAction, isProgress = false) =>
        dispatch(UpdateActions(actionId, { ...foundAction }, isProgress, { showLoader: false })),
      500
    ),
    []
  ); */

  const onAddMetricPopupOpenHandle = () => {
    setIsAddCustomMetric(true);
  };

  const onAddMetricPopupCloseHandle = () => {
    setIsAddCustomMetric(false);
  };

  const onManageToggleHandle = (action) => {
    if (action) onAddMetricPopupOpenHandle();
    setIsManageMetric((prev) => !prev);
  };

  const handleChange = async (
    e,
    id,
    actionId,
    i,
    actionIndex,
    isProgress,
    isRedux = true
  ) => {
    // Use selectedGoalAction as the primary data source
    let actionsCopy = [...selectedGoalAction.goal.actions];
    let foundActionIndex = actionsCopy.findIndex(
      (item) => item?.id === actionId
    );

    let foundAction =
      e.target.name === "deadline" || e.target.name === "startline"
        ? {
            ...actionsCopy[foundActionIndex],
            [e.target.name]: e.target.value,
          }
        : {
            ...actionsCopy[foundActionIndex],
            [e.target.name || e.target?.attributes?.name?.value]:
              e.target.value !== undefined && e.target.value !== null
                ? e.target.value
                : e.target.innerText !== undefined &&
                  e.target.innerText !== null
                ? e.target.innerText
                : e.target.name === "completed" && e.target.value,
          };

    actionsCopy[foundActionIndex] = foundAction;
    
    // Create updated goal object based on selectedGoalAction
    let findedObj = {
      ...selectedGoalAction,
      goal: {
        ...selectedGoalAction.goal,
        actions: actionsCopy
      }
    };

    if (e.target.name === "completed") {
      findedObj.goal.actions = [...getPrioritizedActionItems({ ...findedObj })];

      await dispatch(
        UpdateActions(actionId, { completed: foundAction.completed }, isProgress, {
          showLoader: false,
        })
      );

      prioritizeActionItems({ ...findedObj }, findedObj?.id, {
        shouldUpdate: false,
        showLoader: false,
      });
    } else {
      if (isRedux) {
        const foundActionExcludingCompleted = { ...foundAction, completed: undefined };
        debouncedHandleUpdate(actionId, { ...foundActionExcludingCompleted }, isProgress);

        setTimeout(() => {
          $delay.current = false;
        }, 500);
      } else {
        $delay.current = true;
      }
    }

    dispatch(SetSelectedGoalAction({ ...findedObj, goal: { ...findedObj.goal, gap_percentage: selectedGoalAction.goal?.gap_percentage }, i }, e.target.name === "completed"));
    
    // Update actionPlanData to keep it in sync
    let dataCopy = [...actionPlanData];
    let actionPlanDataIndex = dataCopy.findIndex((item) => item?.id === id);
    if (actionPlanDataIndex !== -1) {
      dataCopy[actionPlanDataIndex] = findedObj;
      setActionPlanData(dataCopy);
    }
  };

  const handleAccountabilityCreate = (value, callback) => {
    const existingAccountability = [...accountabilityData, ...customAccountabilityData].find(
      (item) => item.name === value
    );

    if (existingAccountability) {
      callback(null);
      return;
    }

    const formData = new FormData();

    formData.append('name', value);
    formData.append('domain', masterPlanDetails?.journey?.id);
    formData.append('user', getCookie('userData') ? JSON.parse(getCookie('userData')).id : null);
    formData.append('is_custom', true);

    dispatch(CreateAccountability(formData, callback));
  };

  const handleGoalChange = (e, id, i) => {
    let dataCopy = [...actionPlanData];
    let findedObj = dataCopy?.find((item) => item?.id === id);

    if (e.target.name === "startline" && findedObj?.goal?.deadline) {
      let isError = validateDate(findedObj?.goal?.deadline, e.target.value);
      if (isError) return Error(isError);
    }

    findedObj.goal = { ...findedObj?.goal, [e.target.name]: e.target.value };
    
    // When goal is marked as completed, mark all its action items as completed
    if (e.target.name === 'completed' && e.target.value === true) {
      if (findedObj.goal.actions && findedObj.goal.actions.length > 0) {
        findedObj.goal.actions = findedObj.goal.actions.map(action => ({
          ...action,
          completed: true
        }));
      }
    }
    
    // When goal is marked as uncompleted, keep all action items as completed
    if (e.target.name === 'completed' && e.target.value === false) {
      if (findedObj.goal.actions && findedObj.goal.actions.length > 0) {
        // Keep all action items as completed when uncompleting a goal
        findedObj.goal.actions = findedObj.goal.actions.map(action => ({
          ...action,
          completed: true
        }));
      }
    }

    dataCopy[i] = findedObj;

    dispatch(SetSelectedGoalAction({ ...findedObj, i }));
    dispatch(
      UpdateGoal(findedObj.goal?.id, { [e.target.name]: e.target.value })
    );
    setActionPlanData(dataCopy);
  };

  const handleGoalUpdate = (form, areaId, goalId, callback) => {
    const onCallback = () => {
      if (callback) {
        callback();
      }
    }

    dispatch(UpdateGoal(goalId, form, onCallback));

    setActionPlanData(prev => {
      const updatedData = [...prev];
      const areaIndex = updatedData.findIndex(item => item.id === areaId);
      
      if (areaIndex !== -1) {
        updatedData[areaIndex] = {
          ...updatedData[areaIndex],
          goal: {
            ...updatedData[areaIndex].goal,
            ...form,
          },
        };
      }
      
      return updatedData;
    });
  };

  const handleCompleteAction = ({ e, id }) => {
    // Goal completion is now handled immediately in handleToggleCompleteGoal
    // This function now just closes the modal
    setOpen(null);
  };

  const handleAddMore = (id) => {
    setTimeout(
      () => {
        let dataCopy = [...actionPlanData];
        let actionObj = {
          habit: false,
        };
        let findedObj = dataCopy?.find((item) => item?.id === id);

        dispatch(
          CreateAction(
            { ...actionObj, goal: findedObj?.goal?.id },
            (data) => {
              const goalAction = { ...selectedGoalAction };
              goalAction.goal = {
                ...goalAction.goal,
                actions: [...goalAction.goal.actions, data],
              };

              prioritizeActionItems({ ...goalAction }, goalAction.id, { propagate: true }, data.id);

              // Amplitude
              track("Goal Action Item Created", {
                goal_id: findedObj?.goal?.id
              });
            },
            { update: false }
          )
        );
      },
      $delay.current ? 500 : 0
    );
  };

  const handleOrderAgain = (arr, start, end) => {
    let copyArr = [...arr];
    let element = copyArr.splice(start, 1)[0];
    copyArr.splice(end, 0, element);
    return copyArr;
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    // First, sort the array so that completed: false items are at the top
    let sortedActions = selectedGoalAction?.goal?.actions
      .sort((a, b) => (a.completed === b.completed ? 0 : a.completed ? 1 : -1));

    let orderedArr = handleOrderAgain(
      sortedActions,
      result?.source?.index,
      result?.destination?.index
    );

    // Update selectedGoalAction with reordered actions
    const updatedSelectedGoalAction = {
      ...selectedGoalAction,
      goal: {
        ...selectedGoalAction.goal,
        actions: orderedArr.map((item, i) => ({ ...item, priority: i }))
      }
    };

    // Update actionPlanData to keep it in sync
    let copyActionPlans = [...actionPlanData];
    let parentIndex = actionPlanData.findIndex(
      (item) => item?.id === selectedGoalAction?.id
    );

    if (parentIndex !== -1) {
      copyActionPlans[parentIndex] = updatedSelectedGoalAction;
      setActionPlanData([...copyActionPlans]);
    }

    dispatch(SetSelectedGoalAction(updatedSelectedGoalAction));

    let masterplanId = getCookie("MasterPlanId");

    dispatch(
      PrioritizeActionPlan(
        masterplanId,
        orderedArr?.map((action, i) => {
          return {
            action: action?.id,
            priority: i,
          };
        }),
        { showLoader: false }
      )
    );
  };

  const getPrioritizedActionItems = (goalAction) => {
    let sortedActions = goalAction?.goal?.actions.sort((a, b) =>
      a.completed === b.completed ? 0 : a.completed ? 1 : -1
    );

    return sortedActions?.map((action, i) => {
      return {
        ...action,
        priority: i,
      };
    });
  };

  const prioritizeActionItems = (
    goalAction,
    goalId,
    { shouldUpdate = true, showLoader = true, propagate = false } = {},
    actionId
  ) => {
    const masterplanId = getCookie("MasterPlanId");
    let actions = [...goalAction?.goal?.actions];

    // Separate completed and uncompleted actions
    let uncompleted = actions.filter(a => !a.completed);
    let completed = actions.filter(a => a.completed);

    // Find the action that needs to be moved down
    let actionToMove = uncompleted.find(a => a.id === actionId);
    uncompleted = uncompleted.filter(a => a.id !== actionId); // Remove from list

    // Sort uncompleted actions by their original index (preserve order)
    uncompleted.sort((a, b) => a.priority - b.priority);

    // Append the actionId (if exists) at the end of uncompleted list
    if (actionToMove) {
      uncompleted.push(actionToMove);
    }

    // Combine sorted uncompleted actions with completed ones
    let sortedActions = [...uncompleted, ...completed];

    const items = sortedActions.map((action, i) => {
      return {
        action: action?.id,
        priority: i,
      };
    });

    dispatch(
      PrioritizeActionPlan(masterplanId, items, {
        propagate,
        callback: (data) => {
          if (!shouldUpdate) return;

          let findedObj = [...data.areas].find((item) => item?.id === goalId);

          dispatch(
            SetSelectedGoalAction({
              ...selectedGoalAction,
              goal: { ...selectedGoalAction?.goal, ...findedObj?.goal },
            })
          );
          
          // Update actionPlanData after dispatching SetSelectedGoalAction
          setActionPlanData(prev => {
            const updatedData = [...prev];
            const areaIndex = updatedData.findIndex(item => item.id === goalId);
            
            if (areaIndex !== -1) {
              updatedData[areaIndex] = {
                ...updatedData[areaIndex],
                goal: {
                  ...updatedData[areaIndex].goal,
                  ...findedObj?.goal,
                },
              };
            }
            
            return updatedData;
          });
          
          $delay.current = false;
        },
        showLoader,
      })
    );
  };

  const onMenuClick = (goalId, actionId, i, key, actionIndex, isProgress) => {
    if (key === "1") {
      let foundAction = selectedGoalAction?.goal?.actions?.find(
        (action) => action?.id === actionId
      );

      handleChange(
        { target: { value: !foundAction?.completed, name: "completed" } },
        goalId,
        actionId,
        i,
        actionIndex,
        isProgress
      );
    }
    if (key === "2") {
      let foundAction = selectedGoalAction?.goal?.actions?.find(
        (action) => action?.id === actionId
      );

      let res = selectedGoalAction?.goal?.actions?.filter(
        (action) => action?.id !== actionId
      );

      const modifiedObj = {
        ...selectedGoalAction,
        goal: {
          ...selectedGoalAction.goal,
          actions: [...res],
        },
      };

      if (foundAction?.isNew) {
        dispatch(SetSelectedGoalAction({ ...modifiedObj, i }));
        let actionPlanDataCopy = [...actionPlanData];
        setActionPlanData(actionPlanDataCopy);
      } else {
        dispatch(
          DeleteActions(actionId, () =>
            prioritizeActionItems(modifiedObj, goalId)
          )
        );
      }
    }
  };

  const validateDate = (deadline, startline) => {
    let isSame = moment(deadline).isSame(startline);
    if (isSame) return "Startline and Deadline should not same.";
    let validate = moment(deadline).isBefore(startline);
    if (validate) return "Startline must before Deadline.";
  };

  const handleSwitch = (e) => {
    dispatch(SetSelectedGoalAction({ ...selectedGoalAction, is_private: !e } ));
    dispatch(UpdateUserArea(selectedGoalAction?.id, { is_private: !e }));
  };

  // Function to handle area name updates
  const handleAreaNameUpdate = (areaName, id, i, isCustom, color, callback) => {
    let dataCopy = [...actionPlanData];
    let findedObj = dataCopy?.find((item) => item?.id === id);

    if (!findedObj) return;

    // Update local data with name, is_custom, and color if provided
    findedObj = {
      ...findedObj,
      name: areaName,
      is_custom: isCustom,
      goal: {
        ...findedObj.goal,
        category_name: ""
      }
    };

    findedObj.color = color ?? "#808080";
    dataCopy[i] = findedObj;

    // Update Redux state
    dispatch(SetSelectedGoalAction({ ...findedObj, i }));

    // Prepare update data
    const updateData = {
      name: areaName,
      is_custom: isCustom
    };

    // Update area name in the database
    dispatch(UpdateUserArea(findedObj?.id, updateData, () => {
      if (callback) callback();
    }));

    setActionPlanData(dataCopy);
  };

  const arrLength = selectedGoalAction?.goal?.actions?.filter(item => !item.completed).length;
  const contextRefs = useRef([]);
  const deadlineRefs = useRef([]);
  const deadlineDateRefs = useRef([]);
  const startlineRefs = useRef([]);
  const startlineDateRefs = useRef([]);
  const accRefs = useRef([]);
  const habitRefs = useRef([]);

  const handleEnterKeyDown = index => {
    const nextIndex = index + 1;

    if (nextIndex === contextRefs.current.length) {
      $addButtonRef.current?.focus();
    }
    else if (nextIndex < contextRefs.current.length && contextRefs.current[nextIndex].current?.focusInput) {
      contextRefs.current[nextIndex].current?.focusInput();
    }
  }

  if (contextRefs.current.length !== arrLength) {
    contextRefs.current = Array(arrLength)
      .fill()
      .map((_, i) => {
        let data = {
          current: contextRefs.current[i],
          ref: createRef(),
          i,
        };
        return data;
      });
  }

  if (deadlineRefs.current.length !== arrLength) {
    deadlineRefs.current = Array(arrLength)
      .fill()
      .map((_, i) => deadlineRefs.current[i] || createRef());
    deadlineDateRefs.current = Array(arrLength)
      .fill()
      .map((_, i) => deadlineDateRefs.current[i] || createRef());
  }
  if (startlineRefs.current.length !== arrLength) {
    startlineRefs.current = Array(arrLength)
      .fill()
      .map((_, i) => startlineRefs.current[i] || createRef());
    startlineDateRefs.current = Array(arrLength)
      .fill()
      .map((_, i) => startlineDateRefs.current[i] || createRef());
  }
  if (accRefs.current.length !== arrLength) {
    accRefs.current = Array(arrLength)
      .fill()
      .map((_, i) => {
        let data = {
          current: accRefs.current[i],
          ref: createRef(),
          i,
        };
        return data;
      });
  }
  if (habitRefs.current.length !== arrLength) {
    habitRefs.current = Array(arrLength)
      .fill()
      .map((_, i) => {
        let data = {
          current: habitRefs.current[i],
          ref: createRef(),
          i,
        };
        return data;
      });
  }

  const handleFocus = (e, i, type, nextType) => {
    if (e.key === "Tab") {
      e.preventDefault();

      const refs = {
        context: contextRefs,
        accountability: accRefs,
        habit: habitRefs,
        deadlineDate: deadlineDateRefs,
        deadline: deadlineRefs,
        startlineDate: startlineDateRefs,
        startline: startlineRefs,
      };

      /* if (arrLength - 1 === i) {
        refs[type]?.current[i - 1].current.blur();
        refs[nextType]?.current[0].current.focus();
      } else {
        refs[type]?.current[i].current.blur();
        refs[type]?.current[i + 1].current.focus();
      } */
    }
  };

  const handlePrev = () => {
    navigate(PURPOSE_PATH);
  };

  const handleNext = () => {
    // Check if any goals are missing categories
    const goalsWithoutCategory = masterPlanDetails?.areas?.filter(area =>
      !area?.goal?.category_name || area?.goal?.category_name.trim() === ''
    );

    if (goalsWithoutCategory && goalsWithoutCategory.length > 0) {
      Notify.error("Please assign a category to each goal before proceeding.");
      return;
    }

    const formData = new FormData();
    formData.append("step", 6);
    dispatch(UpdateLastStep(formData));
    navigate(MASTER_PATH);
  };

  const handleAssistantSelect = (actionItems, selectedActionId) => {
    let dataCopy = [...actionPlanData];
    let findedObj = dataCopy?.find(
      (item) => item?.id === selectedGoalAction?.id
    );

    const newActionItems = [];
    const newActionItemsIds = [];

    const createActionAsync = (actionObj, findedObj, dispatch) => {
      return new Promise((resolve) => {
        dispatch(
          CreateAction({ ...actionObj, goal: findedObj?.goal?.id }, (data) => {
            resolve(data);
          })
        );
      });
    };

    const updateActionAsync = (actionId, updatedActionItem, dispatch) => {
      return new Promise((resolve) => {
        dispatch(
          UpdateActions(actionId, { ...updatedActionItem }, false, {
            callback: () => resolve(updatedActionItem),
            showLoader: false,
          })
        );
      });
    };

    const processActions = async (actionItems, findedObj, dispatch) => {
      const actions =
        findedObj?.goal?.actions.filter((action) => !action?.completed) || [];

      let actionIndex = actions.findIndex(
        (action) => action.id === selectedActionId
      );
      let remainingActionItems = [...actionItems];

      // Use empty action items if available
      for (
        let i = actionIndex;
        i < actions.length && remainingActionItems.length > 0;
        i++ /* , j++ */
      ) {
        if (!actions[i]?.context || actions[i]?.id === selectedActionId) {
          let actionItem = remainingActionItems.shift();

          actions[i] = {
            ...actions[i],
            context: actionItem?.text,
            type: actionItem?.type,
            accountability: actionItem?.accountability,
            habit: actionItem?.type === "Habit",
          };

          try {
            await updateActionAsync(actions[i].id, actions[i], dispatch);
          } catch (error) {
            console.error(error);
          }
        }
      }

      // Create new actions for any remaining items
      for (const actionItem of remainingActionItems) {
        let actionObj = {
          context: actionItem?.text,
          type: actionItem?.type,
          accountability: actionItem?.accountability,
          habit: actionItem?.type === "Habit",
          priority: actions.length + newActionItems.length,
        };

        try {
          const data = await createActionAsync(actionObj, findedObj, dispatch);
          newActionItems.push(data);
          newActionItemsIds.push(data.id);
        } catch (error) {
          console.error(error);
        }
      }

      prioritizeActionItems(
        {
          ...findedObj,
          goal: {
            ...findedObj?.goal,
            actions: [...actions, ...newActionItems],
          },
        },
        findedObj?.id,
        { showLoader: false, propagate: true }
      );
    };

    // Call processActions with your actionItems, findedObj, and dispatch function
    processActions(actionItems, findedObj, dispatch);
  };

  const handleToggleCompleteGoal = () => {
    const { goal, id, i } = selectedGoalAction || {};

    const payload = {
      target: {
        value: !goal?.completed,
        name: "completed",
      },
    };

    if (goal?.completed) {
      // Update the goal state immediately
      handleGoalChange(payload, id, i);

      // Refresh master plan details to update both Actions and GoalsSection components
      setTimeout(() => {
        const MasterPlanId = getCookie("MasterPlanId");

        dispatch(RetrieveMasterPlanDetails(MasterPlanId, false));
        dispatch(clearTemporarilyVisibleCompletedGoals());
      }, 1000); // Small delay to ensure the goal update is processed
    } else {
      // If checking to complete goal - capture action items that are currently not completed
      const uncompletedActionIds = goal?.actions
        ?.filter(action => !action.completed)
        ?.map(action => action.id) || [];
      
      // Dispatch request immediately
      handleGoalChange(payload, id, i);
      
      // Add the goal to temporarily visible completed goals list
      dispatch(addTemporarilyVisibleCompletedGoal(goal?.id));
      
      // Store reference to completed goal for undo functionality with uncompleted action IDs
      const completedGoal = {
        ...selectedGoalAction,
        uncompletedActionIds // Store the IDs of action items that were not completed
      };
      
      // Refresh master plan details to update both Actions and GoalsSection components
      setTimeout(() => {
        const MasterPlanId = getCookie("MasterPlanId");
        dispatch(RetrieveMasterPlanDetails(MasterPlanId));
      }, 100); // Small delay to ensure the goal update is processed
      
      // Open modal with reference to completed goal
      setOpen({ e: payload, id, completedGoal });
    }

    dispatch(GetActionsProgress(goal?.id));

    // Amplitude
    track("Goal Completed", {
      goal_id: id,
      goal_completed: !goal?.completed
    });
  };

  const handleUndoCompleteGoal = (completedGoal) => {
    // Mark the goal as not completed
    dispatch(UpdateGoal(completedGoal.goal.id, { completed: false }, () => {
      setTimeout(() => {
        // Restore action items that were not completed before the goal completion
        if (completedGoal.uncompletedActionIds && completedGoal.uncompletedActionIds.length > 0) {
          // Send individual requests to mark each action item as not completed
          completedGoal.uncompletedActionIds.forEach(actionId => {
            dispatch(UpdateActions(actionId, { completed: false }, false, { showLoader: false }));
          });
        }

        const updatedActions = completedGoal.goal.actions.map(action => {
          // Restore action items that were not completed before goal completion
          if (completedGoal.uncompletedActionIds && completedGoal.uncompletedActionIds.includes(action.id)) {
            return { ...action, completed: false };
          }
          return action;
        });
        
        dispatch(SetSelectedGoalAction({
          ...completedGoal,
          goal: {
            ...completedGoal.goal,
            actions: updatedActions,
            completed: false
          }
        }));
      }, 100);
    }));

    setTimeout(() => {
      dispatch(clearTemporarilyVisibleCompletedGoals()); // Clear temporarily visible completed goals
    }, 100); // Small delay to ensure the goal update is processed
  };

  const handleAccountabilitySelect = item => {
    let label = item?.label;

    if (typeof item?.label !== 'string') {
      label = item?.label.props.label;
    }

    handleGoalChange(
      {
        target: {
          value: label,
          name: "accountability",
        },
      },
      selectedGoalAction?.id,
      selectedGoalAction?.i
    );
  }

  const userData = JSON.parse(getCookie("userData"));
  const isLocked =
    selectedGoalAction?.is_private && userData?.id !== selectedGoalAction?.user;

  const goalProgress = selectedGoalAction?.goal?.gap_percentage
    ? Math.ceil(Math.abs(100 - selectedGoalAction?.goal?.gap_percentage))
    : 0;

  let actionsLength = 0;
  let completedActionsLength = 0;

  if (selectedGoalAction?.goal?.actions) {
    actionsLength = selectedGoalAction.goal.actions.length;
    completedActionsLength = selectedGoalAction.goal.actions.filter(
      (action) => action?.completed
    ).length;
  }

  const selectedAccountability = getOptionWithLabel(selectedGoalAction?.goal?.accountability, accountabilityData, customAccountabilityData) || undefined;

  const handleAccountabilityDeselect = value => {
    if (selectedAccountability?.value !== value)
      return;
  
    handleGoalChange(
      {
        target: {
          value: "",
          name: "accountability",
        },
      },
      selectedGoalAction?.id,
      selectedGoalAction?.i
    );
  }

  const accountabilityOptions = getGroupedOptions(accountabilityData, customAccountabilityData, handleAccountabilityDeselect);

  return (
    <StepLayout
      title="6-10. Goal Action Plan"
      progressPosition={isMobile ? "col" : "row"}
      progress={
        isLocked ? (
          <div style={{ minHeight: 38 }} />
        ) : isMobile ? (
          <Styles.ExtraHeader>
            <Tooltip
              placement="leftTop"
              type="tertiary"
              title="Measurements"
              text="Track and quantify progress toward your goals."
              alternative
              align={{
                offset: [0, 6],
              }}
            >
              <Styles.ProgressWrapper $width={window.innerWidth / 2}>
                <Styles.ProgressLabel>Goal Progress</Styles.ProgressLabel>
                <RadialBar value={goalProgress} />
              </Styles.ProgressWrapper>
            </Tooltip>

            <Styles.ProgressWrapper>
              <Styles.ProgressLabel>Plan Progress</Styles.ProgressLabel>
              <RadialBar value={actionsProgress?.progress || "0"} />
            </Styles.ProgressWrapper>
          </Styles.ExtraHeader>
        ) : (
          <>
            <Tooltip
              placement="leftTop"
              type="tertiary"
              title="Goal Progress"
              text="Tells you how close you are to your big goal using the numbers you chose (start, now, and finish)."
              alternative
              align={{
                offset: [0, 6],
              }}
            >
              <Styles.ProgressWrapper>
                <Styles.ProgressLabel>Goal Progress</Styles.ProgressLabel>
                <RadialBar value={goalProgress} />
              </Styles.ProgressWrapper>
            </Tooltip>

            <Tooltip
              placement="leftTop"
              type="tertiary"
              title="Plan Progress"
              text="Shows how many Action Items you've finished out of all the Action Items in this plan."
              alternative
              align={{
                offset: [0, 6],
              }}
            >
              <Styles.ProgressWrapper>
                <Styles.ProgressLabel>Plan Progress</Styles.ProgressLabel>
                <RadialBar value={actionsProgress?.progress || "0"} />
              </Styles.ProgressWrapper>
            </Tooltip>

            <Print data={selectedGoalAction} />
          </>
        )
      }
      pagination={
        <Pagination
          i={selectedGoalAction?.i}
          actionPlanData={SortArr(masterPlanDetails?.areas?.filter(area =>
            !area.goal?.completed || temporarilyVisibleCompletedGoals.has(area.goal?.id)
          ))}
        />
      }
      nextPageTitle="Complete Master Plan"
      isNextDisabled={selectedGoalAction?.i < actionPlanData?.length - 1}
      onPrev={handlePrev}
      onNext={handleNext}
    >
      <AssistantProvider>
        <Styles.Container>
          <Styles.ContainerItem>
            <Styles.TableContainer id="action-items-container">
              <Header
                data={selectedGoalAction}
                isPrivate={isLocked}
                onUpdate={handleGoalUpdate}
                onAreaNameUpdate={handleAreaNameUpdate}
                onAddMetricOpen={onAddMetricPopupOpenHandle}
                onAddMetricToggle={onManageToggleHandle}
                device={
                  !!isMobile ? "Mobile" : !!isTablet ? "Tablet" : "Desktop"
                }
              />

              <Purpose
                data={selectedGoalAction}
                onUpdate={handleGoalUpdate}
                isLocked={isLocked}
              />

              <Styles.Planwrapper>
                <Styles.PlanwrapperContent>
                {isLocked && (
                  <LockedOver customContent="This Goal is private" width="50px" />
                )}
                {!isMobile && !isTablet ? (
                  <>
                    <Styles.Goalsitem>
                      <Styles.Wrapper>
                        <Styles.Content>
                          <Styles.GoalsRow>
                            <Goal onUpdate={handleGoalUpdate} />

                            <Styles.ActionsWrapper
                              $action
                              style={{ marginRight: "2vw" }}
                            >
                              <Styles.GoalsCol $date>
                                <Styles.InputLabel>
                                  8. Startline
                                </Styles.InputLabel>
                                <Styles.InputField className="datepicker-wrapper">
                                  <CustomDatepicker
                                    selected={
                                      selectedGoalAction?.goal?.startline
                                        ? moment(
                                            selectedGoalAction?.goal?.startline
                                          ).toDate()
                                        : null
                                    }
                                    maxDate={moment(
                                      selectedGoalAction?.goal?.deadline
                                    )
                                      .subtract(1, "days")
                                      .toDate()}
                                    placeholderText={"Startline"}
                                    onChange={(date) => {
                                      handleGoalChange(
                                        {
                                          target: {
                                            value: moment(date).isValid()
                                              ? moment(date).format(
                                                  "YYYY-MM-DD"
                                                )
                                              : null,
                                            name: "startline",
                                          },
                                        },
                                        selectedGoalAction?.id,
                                        selectedGoalAction?.i
                                      );
                                    }}
                                  />
                                </Styles.InputField>
                              </Styles.GoalsCol>

                              <Styles.GoalsCol $date>
                                <Styles.InputLabel>
                                  9. Deadline
                                </Styles.InputLabel>
                                <Styles.InputField className="datepicker-wrapper">
                                  <CustomDatepicker
                                    selected={
                                      selectedGoalAction?.goal?.deadline
                                        ? moment(
                                            selectedGoalAction?.goal?.deadline
                                          ).toDate()
                                        : null
                                    }
                                    minDate={selectedGoalAction?.goal?.startline
                                      ? moment(
                                        selectedGoalAction?.goal?.startline
                                      ).toDate()
                                      : null}
                                    placeholderText={"Deadline"}
                                    onChange={(date) => {
                                      handleGoalChange(
                                        {
                                          target: {
                                            value: moment(date).isValid()
                                              ? moment(date).format(
                                                  "YYYY-MM-DD"
                                                )
                                              : null,
                                            name: "deadline",
                                          },
                                        },
                                        selectedGoalAction?.id,
                                        selectedGoalAction?.i
                                      );
                                    }}
                                  />
                                </Styles.InputField>
                              </Styles.GoalsCol>
                            </Styles.ActionsWrapper>

                            <Styles.GoalsCol $accountability>
                              <Styles.InputLabel>
                                10. Accountability
                              </Styles.InputLabel>
                              <AccountabilitySelect
                                options={accountabilityOptions}
                                value={selectedAccountability}
                                onSelect={handleAccountabilitySelect}
                                onCreate={handleAccountabilityCreate}
                              />
                            </Styles.GoalsCol>

                            <Styles.GoalsCol $space />

                            <Styles.GoalsCol $habit>
                              {SelectedClient ? (
                                <Styles.TogglePlaceholder />
                              ) : (
                                <Toggle
                                  id="private_goal_toggle"
                                  checked={selectedGoalAction?.is_private}
                                  label="PRIVATE"
                                  labelFirst
                                  size="sm"
                                  onChange={() =>
                                    handleSwitch(
                                      selectedGoalAction?.is_private,
                                      selectedGoalAction?.id,
                                      selectedGoalAction?.i
                                    )
                                  }
                                />
                              )}

                              <Tooltip title={selectedGoalAction?.goal?.completed ? "Uncomplete Goal" : "Complete Goal"} alternative>
                                <>
                                  <Checkbox
                                    id={`complete_goal_${selectedGoalAction?.id}`}
                                    checked={selectedGoalAction?.goal?.completed}
                                    onChange={handleToggleCompleteGoal}
                                  />
                                </>
                              </Tooltip>
                            </Styles.GoalsCol>
                          </Styles.GoalsRow>
                        </Styles.Content>
                      </Styles.Wrapper>
                    </Styles.Goalsitem>

                    <Styles.Step1 isWidth={true} isMargin={true}>
                      <Styles.RowWrapper>
                        <Styles.HeadCol $actions $width={"calc(28% + 80px)"}>
                          <Styles.Item style={{ flex: 1 }}>
                            6. Enter Actions
                          </Styles.Item>
                          <Styles.Item style={{ width: 80 }}>
                            7. Prioritize
                          </Styles.Item>
                        </Styles.HeadCol>

                        <Styles.HeadCol $deadline>
                          <Styles.Item style={{ width: "7vw" }}>
                            8. Startline
                          </Styles.Item>
                          <Styles.Item style={{ width: "7vw" }}>
                            9. Deadline
                          </Styles.Item>
                        </Styles.HeadCol>

                        <Styles.HeadCol
                          $width={isLargTablet ? "20%" : "14%"}
                          style={{ marginRight: 20 }}
                        >
                          <Styles.Item>10. Accountability</Styles.Item>
                        </Styles.HeadCol>

                        <Styles.HeadCol $width="140px">
                          <Styles.Item $type>
                            Select Type <TypeTooltip />
                          </Styles.Item>
                        </Styles.HeadCol>

                        <Styles.HeadCol $width="51px" $last></Styles.HeadCol>
                      </Styles.RowWrapper>
                    </Styles.Step1>
                  </>
                ) : (
                  <>
                    <Styles.Goalsitem>
                      <Styles.Wrapper>
                        <Styles.Content>
                          <Styles.GoalsRow>
                            <Styles.GoalsWrap>
                              <Goal onUpdate={handleGoalUpdate} />

                              <Styles.GoalsCol $habit>
                                {SelectedClient ? (
                                  <Styles.TogglePlaceholder />
                                ) : (
                                  <Toggle
                                    id="private_goal_toggle"
                                    checked={selectedGoalAction?.is_private}
                                    label="PRIVATE"
                                    labelFirst
                                    size="sm"
                                    onChange={() =>
                                      handleSwitch(
                                        selectedGoalAction?.is_private,
                                        selectedGoalAction?.id,
                                        selectedGoalAction?.i
                                      )
                                    }
                                  />
                                )}

                                <Tooltip title={selectedGoalAction?.goal?.completed ? "Uncomplete Goal" : "Complete Goal"} alternative>
                                  <>
                                    <Checkbox
                                      id={`complete_goal_${selectedGoalAction?.id}`}
                                      checked={selectedGoalAction?.goal?.completed}
                                      onChange={handleToggleCompleteGoal}
                                    />
                                  </>
                                </Tooltip>
                              </Styles.GoalsCol>
                            </Styles.GoalsWrap>

                            <Styles.ActionsWrappers>
                              <Styles.ActionsWrapper style={{ width: isTablet ? '40%' : '100%'}} $action>
                                <Styles.GoalsCol $date>
                                  <Styles.InputLabel>
                                    8. Startline
                                  </Styles.InputLabel>
                                  <Styles.InputField $leftAlign className="datepicker-wrapper">
                                    <CustomDatepicker
                                      selected={
                                        selectedGoalAction?.goal?.startline
                                          ? moment(
                                              selectedGoalAction?.goal
                                                ?.startline
                                            ).toDate()
                                          : null
                                      }
                                      maxDate={moment(
                                        selectedGoalAction?.goal?.deadline
                                      )
                                        .subtract(1, "days")
                                        .toDate()}
                                      placeholderText={"Startline"}
                                      onChange={(date) => {
                                        handleGoalChange(
                                          {
                                            target: {
                                              value: moment(date).isValid()
                                                ? moment(date).format(
                                                    "YYYY-MM-DD"
                                                  )
                                                : null,
                                              name: "startline",
                                            },
                                          },
                                          selectedGoalAction?.id,
                                          selectedGoalAction?.i
                                        );
                                      }}
                                    />
                                  </Styles.InputField>
                                </Styles.GoalsCol>

                                <Styles.GoalsCol $date>
                                  <Styles.InputLabel>
                                    9. Deadline
                                  </Styles.InputLabel>
                                  <Styles.InputField $leftAlign  className="datepicker-wrapper">
                                    <CustomDatepicker
                                      selected={
                                        selectedGoalAction?.goal?.deadline
                                          ? moment(
                                              selectedGoalAction?.goal?.deadline
                                            ).toDate()
                                          : null
                                      }
                                      minDate={selectedGoalAction?.goal?.startline
                                        ? moment(
                                          selectedGoalAction?.goal?.startline
                                        ).toDate()
                                        : null}
                                      placeholderText={"Deadline"}
                                      onChange={(date) => {
                                        handleGoalChange(
                                          {
                                            target: {
                                              value: moment(date).isValid()
                                                ? moment(date).format(
                                                    "YYYY-MM-DD"
                                                  )
                                                : null,
                                              name: "deadline",
                                            },
                                          },
                                          selectedGoalAction?.id,
                                          selectedGoalAction?.i
                                        );
                                      }}
                                    />
                                  </Styles.InputField>
                                </Styles.GoalsCol>
                              </Styles.ActionsWrapper>

                              <Styles.GoalsCol $accountability>
                                <Styles.InputLabel>
                                  10. Accountability
                                </Styles.InputLabel>
                                <AccountabilitySelect
                                  options={accountabilityOptions}
                                  value={selectedAccountability}
                                  onSelect={handleAccountabilitySelect}
                                  onCreate={handleAccountabilityCreate}
                                />
                              </Styles.GoalsCol>
                            </Styles.ActionsWrappers>
                            <Styles.GoalsCol $space />
                          </Styles.GoalsRow>
                        </Styles.Content>
                      </Styles.Wrapper>
                    </Styles.Goalsitem>
                  </>
                )}
                <Styles.DragDropContainer>
                  <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId={`${selectedGoalAction?.id}`}>
                      {(provided) => (
                        <Styles.Wrapper
                          className="characters"
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                        >
                          {selectedGoalAction?.goal?.actions
                            ?.sort((a, b) => a.priority - b.priority)
                            ?.filter((action) => !action?.completed)
                            ?.map((action, actionIndex) => (
                              <DraggableActionItem
                                draggableId={action.id}
                                index={actionIndex}
                                action={action}
                                actionIndex={actionIndex}
                                selectedGoalAction={selectedGoalAction}
                                accountabilities={accountabilityData}
                                customAccountabilities={customAccountabilityData}
                                // strategies={strategies}
                                domainId={masterPlanDetails?.journey?.id}
                                canBeDeleted={
                                  selectedGoalAction?.goal?.actions?.filter(
                                    (action) => !action?.completed
                                  ).length > 2
                                }
                                onChange={handleChange}
                                onAccountabilityCreate={handleAccountabilityCreate}
                                onFocus={handleFocus}
                                onMenuClick={onMenuClick}
                                onAssistantSelect={handleAssistantSelect}
                                onEnterKeyDown={handleEnterKeyDown}
                                ref={contextRefs.current[actionIndex]}
                                key={action.id}
                              />
                            ))}

                          {provided.placeholder}

                          <Styles.PlanwrapperHeading>
                            <Toggle
                              id="completed_actions_toggle"
                              checked={showCompletedActions}
                              label="SHOW COMPLETED ACTION ITEMS"
                              size="sm"
                              onChange={(e) =>
                                setShowCompletedActions(e.target.checked)
                              }
                            />
                            {/* <Checkbox
                              onChange={(e) =>
                                setShowCompletedActions(e.target.checked)
                              }
                              checked={showCompletedActions}
                            >
                              Show Completed Actions
                            </Checkbox> */}

                            <Styles.AddButton
                              type="button"
                              ref={$addButtonRef}
                              disabled={loading || masterplanLoading}
                              onClick={() =>
                                handleAddMore(
                                  selectedGoalAction?.id,
                                  selectedGoalAction?.i
                                )
                              }
                            >
                              <img src={plusIcon} alt="+" />
                              Action Item
                            </Styles.AddButton>
                          </Styles.PlanwrapperHeading>
                        </Styles.Wrapper>
                      )}
                    </Droppable>
                  </DragDropContext>
                </Styles.DragDropContainer>


                {showCompletedActions && (
                  <Styles.CompletedActionsList>
                    {selectedGoalAction?.goal?.actions
                      ?.filter((action) => action?.completed)
                      ?.map((action, actionIndex) => (
                        <ActionItem
                          isDraggable={false}
                          $color={selectedGoalAction?.color}
                          $isHighlighted={
                            (actionIndex === 0 || actionIndex === 1) &&
                            !action?.completed
                          }
                          actionIndex={actionIndex}
                          action={action}
                          selectedGoalAction={selectedGoalAction}
                          canBeDeleted
                          onMenuClick={onMenuClick}
                          ref={contextRefs.current[actionIndex]}
                          key={action.id}
                        />
                      ))}
                  </Styles.CompletedActionsList>
                )}
                </Styles.PlanwrapperContent>
              </Styles.Planwrapper>

              <Styles.Disclaimer>
                NOTE: First two action items should be reflected on your Master
                Plan
              </Styles.Disclaimer>

              <PlanShortcut
                isVisible={masterPlanDetails?.viewed_masterplan_screen}
              />
            </Styles.TableContainer>
          </Styles.ContainerItem>
        </Styles.Container>
      </AssistantProvider>

      <CompleteActionItemModal
        setOpen={setOpen}
        open={open}
        onComplete={handleCompleteAction}
        onUndo={handleUndoCompleteGoal}
      />

      <CreateMetricsPopup
        active={isAddCustomMetric}
        onClose={onAddMetricPopupCloseHandle}
      />

      <ManageMetricsPopup
        active={isManageMetric}
        onClose={onManageToggleHandle}
      />
    </StepLayout>
  );
};

export default Actions;
